import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { Establishment } from "./type";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { getAllEstablishmentTableAPI,postResgisterEstablishmentAPI,putResgisterEstablishmentAPI,
    getEstablishmentByCodeAPI,putActiveEstablishmentAPI,deleteEstablishmentByIdAPI,getAllEstablishmentTableByUserAPI,
    getAllEstablishmentTableByOrganizationAPI,getEstablishmentByIdAPI,deleteEstablishmentMethodByIdAPI,
    getAllGeiEstablishmentAPI,GetSelectableEstablishmentGeiInventoryByOrganizationIdAPI,
    PostEstablismentGeiAPI,DeleteEstablishmentGeiInventoryByIdAPI,
    GetEstablishmentGeiInventoryByIdAPI
} from "../../services/restcall";
import { Console } from "console";


export const GetEstablishmentGeiInventoryById = (id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetEstablishmentGeiInventoryByIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const DeleteEstablishmentGeiInventoryById = (id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await DeleteEstablishmentGeiInventoryByIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);    
        openNotification("Advertencia",message.message[0]);   
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Eliminar","Establecimiento "+validateMessages.deleteSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const PostEstablismentGei = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await PostEstablismentGeiAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {  
       
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const GetSelectableEstablishmentGeiInventoryByOrganizationId = (organizationId:string,geiId:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetSelectableEstablishmentGeiInventoryByOrganizationIdAPI(organizationId,geiId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllGeiEstablishment = (page:number, pageSize:number,geiId:string,organizationId:string,filter:string,orderby:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllGeiEstablishmentAPI(page, pageSize,geiId,organizationId,filter,orderby);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getAllEstablishmentTableByUser = (page:number, pageSize:number,filter:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllEstablishmentTableByUserAPI(page, pageSize,filter);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllEstablishmentTable = (page:number, pageSize:number,filter:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllEstablishmentTableAPI(page, pageSize,filter);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllEstablishmentTableByOrganization = (page:number, pageSize:number,id:string,filter:string,orderYear:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    console.log("Pablo: "+filter);
    
    const responseData = await getAllEstablishmentTableByOrganizationAPI(page, pageSize,id,filter,orderYear);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const deleteEstablishmentMethodById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteEstablishmentMethodByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
        openNotification("Advertencia",message.message[0]);  
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));  
        openNotification("Establecimientos",validateMessages.deleteSuccess);           
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getEstablishmentById = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getEstablishmentByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getEstablishmentByCode = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getEstablishmentByCodeAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putActiveEstablishment = (value:Establishment): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putActiveEstablishmentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Establecimiento "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const postResgisterEstablishment = (value:Establishment): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));

    const responseData = await postResgisterEstablishmentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);   
    }
    else if (responseData.StatusCode === 200) {
   
        openNotification("Ingreso","Establecimiento "+validateMessages.registerSuccess);  
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putResgisterEstablishment = (value:Establishment): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));  
    const responseData = await putResgisterEstablishmentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        openNotification("Advertencia",message.message[0]);       
        
    }
    else if (responseData.StatusCode === 200) {        
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Establecimiento "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));     
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const deleteEstablishmentById = (value: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteEstablishmentByIdAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        openNotification("Actualización","Establecimiento "+ validateMessages.updateSuccess);    
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};